import './App.css';
import Main from './pages/Main';
import { BrowserRouter as Router } from 'react-router-dom';
import { OrdersProvider } from './contexts/OrderContext';
import { useState, useEffect } from 'react';
import Login from './pages/Login';
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";
import { ProgressSpinner } from 'primereact/progressspinner';

function App() {

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, currentUser => {
      setUser(currentUser);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        height: '100vh',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <ProgressSpinner />
      </div>
    );
  }

  return (
    <Router>
      {/* <OrdersProvider> */}

      {
        user ?
          <Main />
          : <Login />
      }
      {/* </OrdersProvider> */}
    </Router>
  );
}

export default App;